import FundingDetails from "./FundingDetails";

export default FundingDetails;
